import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    // Check if targets exist before accessing them
    if (this.hasContentTarget && this.hasIconTarget) {
      const content = this.contentTarget
      const icon = this.iconTarget

      // Set initial collapsed state if not already set
      if (!content.style.display || content.style.display === "") {
        content.style.display = "none"
        icon.style.transform = "rotate(0deg)"
      }
    }
  }

  toggle() {
    const content = this.contentTarget
    const icon = this.iconTarget

    const isCollapsed = content.style.display === "none" || !content.style.display

    if (isCollapsed) {
      // Expand
      content.style.display = "block"
      icon.style.transform = "rotate(90deg)"
    } else {
      // Collapse
      content.style.display = "none"
      icon.style.transform = "rotate(0deg)"
    }
  }

  // Expand this specific category
  expand() {
    if (this.hasContentTarget && this.hasIconTarget) {
      this.contentTarget.style.display = "block"
      this.iconTarget.style.transform = "rotate(90deg)"
    }
  }

  // Collapse this specific category
  collapse() {
    if (this.hasContentTarget && this.hasIconTarget) {
      this.contentTarget.style.display = "none"
      this.iconTarget.style.transform = "rotate(0deg)"
    }
  }
}
